import React from 'react';
import SEOHead from '../SEOHead';
import { PreloadedYouTubeEmbed } from '../PreloadedEmbeds';

const VideosPage = () => {
  const youtubeVideos = [
    { id: '8j8bKsiNcbs', title: 'Ghost In Plain Sight' },
    { id: '6kaOG1t5j8E', title: 'Venomous Crusade' },
    { id: 'd1aevrjBirU', title: 'From The Inside' },
    { id: 'cXtcD7lTsN0', title: 'Masked Reality' },
    { id: 'RzQ22Z82w_w', title: "Autumn's Embrace" },
    { id: 'XMmPcwyy-aQ', title: 'Screen-Lit Youth' },
    { id: '8CIm8pXcuiQ', title: 'OK Boomer (Screen-Lit Youth Response)' }
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    "name": "Exlo Music Videos",
    "description": "Watch Exlo's latest music videos on YouTube. Electronic music with emotional depth and AI-assisted production.",
    "url": "https://music.exlo.no/videos",
    "thumbnailUrl": `${process.env.PUBLIC_URL}/artist_photo.png`,
    "uploadDate": "2024-01-01",
    "author": {
      "@type": "MusicGroup",
      "name": "Exlo",
      "url": "https://music.exlo.no"
    },
    "genre": ["Electronic", "AI-Assisted Music", "Digital Music"]
  };

  return (
    <div className="min-h-screen bg-[#1a1a2e] text-white">
      <SEOHead
        title="Exlo Music Videos - Electronic Music with Emotional Depth"
        description="Watch Exlo's latest music videos on YouTube. Electronic music with emotional depth and AI-assisted production."
        url="/videos"
        type="video.other"
        structuredData={structuredData}
      />
      
      <noscript>
        <div className="p-8 text-center">
          <h1 className="text-3xl font-bold mb-4 text-[#e94560]">Exlo Music Videos</h1>
          <p className="text-lg mb-4">Watch Exlo's latest music videos on YouTube:</p>
          <ul className="list-disc list-inside space-y-2">
            <li><a href="https://www.youtube.com/watch?v=8j8bKsiNcbs" className="text-cyan-400 underline">Ghost In Plain Sight</a></li>
            <li><a href="https://www.youtube.com/watch?v=6kaOG1t5j8E" className="text-cyan-400 underline">Venomous Crusade</a></li>
            <li><a href="https://www.youtube.com/watch?v=d1aevrjBirU" className="text-cyan-400 underline">From The Inside</a></li>
          </ul>
        </div>
      </noscript>

      <div className="p-4 md:p-8 max-w-6xl mx-auto">
        <header className="mb-8">
          <h1 className="text-4xl font-bold mb-4 text-[#e94560]">Music Videos</h1>
          <p className="text-lg text-gray-300">Watch Exlo's latest music videos on YouTube. Each video brings the electronic soundscapes to life with compelling visuals.</p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {youtubeVideos.map((video) => (
            <PreloadedYouTubeEmbed key={video.id} videoId={video.id} videoTitle={video.title} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default VideosPage;
